import TopSection from "../../LT/TopSection";
import { Card, Box, Typography } from "@mui/material";
import Paramsliders,{DEFAULTS} from "./Paramsliders";
import ButtonComponent from "../../../components/common/button/Button";
import OperationalOverrides from "./OperationalOverrides";
import { useEffect, useState } from "react";
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from "react-redux";
import { getActiveGlobalRiskConfig } from "../../../redux/actions/activeGlobalRiskConfigSlice";
const normalizeRole = (role) => (role || "").replace(/\s+/g, "").toLowerCase();
const hasRole = (rawRole, target) =>
  normalizeRole(rawRole).split(",").some((r) => r === target);
const ParamConfig = () => {
  const rawRole = localStorage.getItem("appUserRole") || "AppAdmin";
  const canEditDefaults = hasRole(rawRole, "appadmin");
  const canManageOverrides = hasRole(rawRole, "appadmin") || hasRole(rawRole, "globalplanner") || hasRole(rawRole, "planner");

    const dispatch = useDispatch();
    const [thresholds, setThresholds] = useState(DEFAULTS);
    const [rules,setRules] = useState([]);
    const globalConfig = useSelector((state) => state.activeGlobalRiskConfig?.data?.data ?? null);
    const globalConfigLoading = useSelector((state) => state.activeGlobalRiskConfig?.loading ?? false);

    useEffect(() => {
      dispatch(getActiveGlobalRiskConfig());
    }, [dispatch]);

    useEffect(() => {
      if (!globalConfig) return;

      const toNumber = (val) => {
        if (val === null || val === undefined || val === "") return NaN;
        return Number(val);
      };

      const pickRange = (fromVal, toVal, defRange) => {
        const fromNum = toNumber(fromVal);
        const toNum = toNumber(toVal);
        const safeFrom = Number.isFinite(fromNum) ? fromNum : defRange[0];
        const safeTo = Number.isFinite(toNum) ? toNum : defRange[1];
        return [safeFrom, safeTo];
      };

      const next = {
        high: {
          pdt: pickRange(globalConfig?.high?.pdtFrom, globalConfig?.high?.pdtTo, DEFAULTS.high.pdt),
          variance: pickRange(globalConfig?.high?.varFrom, globalConfig?.high?.varTo, DEFAULTS.high.variance),
          safetyWeeks: Number.isFinite(toNumber(globalConfig?.high?.safetyWeeks))
            ? Number(globalConfig.high.safetyWeeks)
            : DEFAULTS.high.safetyWeeks,
        },
        medium: {
          pdt: pickRange(globalConfig?.medium?.pdtFrom, globalConfig?.medium?.pdtTo, DEFAULTS.medium.pdt),
          variance: pickRange(globalConfig?.medium?.varFrom, globalConfig?.medium?.varTo, DEFAULTS.medium.variance),
          safetyWeeks: Number.isFinite(toNumber(globalConfig?.medium?.safetyWeeks))
            ? Number(globalConfig.medium.safetyWeeks)
            : (DEFAULTS.medium.safetyWeeks ?? 0),
        },
        low: {
          pdt: pickRange(globalConfig?.low?.pdtFrom, globalConfig?.low?.pdtTo, DEFAULTS.low.pdt),
          variance: pickRange(globalConfig?.low?.varFrom, globalConfig?.low?.varTo, DEFAULTS.low.variance),
          safetyWeeks: Number.isFinite(toNumber(globalConfig?.low?.safetyWeeks))
            ? Number(globalConfig.low.safetyWeeks)
            : (DEFAULTS.low.safetyWeeks ?? 0),
        },
      };

      setThresholds(next);
    }, [globalConfig]);
   const handleSave = () => {
    const payload = {
      thresholds,
      operationalOverrides: rules,
    };
    toast.success("Parameters Modified Successfully", {
              autoClose: 4000,
            });
  };
  return (
    <>
      <TopSection
        labelList={[
          { title: "Dashboard", path: "/dashboard" },
          { title: "Parameter Configuration" },
        ]}
        hideHeader={true}
      />

      <Box sx={{  }}>
        <Card
          sx={{
            width: "94%",
            borderRadius: 2,
            margin: "2px auto",
            marginBottom: 2,
            padding: 2,
            minHeight: 56,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: 0.25 }}>
            <Typography variant="h6">Configuration Parameters</Typography>
            <Typography variant="caption" color="text.secondary">
              Adjust the thresholds that trigger automated supply chain risk
              alerts across the global network.
            </Typography>
          </Box>
        </Card>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "96%",
           margin: "2px auto",
           
            
          }}
        >
         <Paramsliders
           value={thresholds}
           onChange={setThresholds}
           showSave={canEditDefaults}
           disabled={!canEditDefaults || globalConfigLoading}
         />
         <Box sx={{mt:2 }}>
          <OperationalOverrides
            rules={rules}
            setRules={setRules}
            canManageOverrides={canManageOverrides}
          />
         </Box>
        
        </Box>
      </Box>
    </>
  );
};

export default ParamConfig;